export default "__VITE_ASSET__Cgcvvqvg__"